var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.multi
    ? _c("app-sell-price-category-select", {
        attrs: {
          value: _vm.singleValue,
          label: _vm.label,
          "use-number": "",
          fancy: "",
        },
        on: {
          input: function ($event) {
            return _vm.setSingleValue($event)
          },
        },
      })
    : _c("app-sell-price-category-multi-select", {
        attrs: { value: _vm.multiSelectValue, label: _vm.label, fancy: "" },
        on: {
          input: function ($event) {
            return _vm.onMultiSelectInput($event)
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }